import React from "react";
import { useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';

const TimberMaterialPicker = ({}, ref) => {
  const { t } = useTranslation();
  const [selectValue, setSelectValue] = React.useState(18);
  const onChange = (event) => {
    const value = event.target.value;
    setSelectValue(value);
    console.log(event.target.value);
  };
  useImperativeHandle(ref, () => ({
    getData: getData,
  }));
  const getData = () => {
    return selectValue;
  };

  return (
    <div class="form-col1_6">
      <label class="form-label" for="grid-ServiceClass">
        {t('Material')}
      </label>
      <select class="form-select" id="grid-ServiceClass" name="grid-ServiceClass" onChange={onChange} defaultValue={selectValue}>
        <option value="1">GL24c EN1194</option>
        <option value="2">GL28c EN1194</option>
        <option value="3">GL32c EN1194</option>
        <option value="4">GL36c EN1194</option>
        <option value="5">GL20c EN14080</option>
        <option value="6">GL22c EN14080</option>
        <option value="7">GL24c EN14080</option>
        <option value="8">GL26c EN14080</option>
        <option value="9">GL28c EN14080</option>
        <option value="10">GL30c EN14080</option>
        <option value="11">GL32c EN14080</option>
        <option value="12">GL24h EN1194</option>
        <option value="13">GL28h EN1194</option>
        <option value="14">GL32h EN1194</option>
        <option value="15">GL36h EN1194</option>
        <option value="16">GL20h EN14080</option>
        <option value="17">GL22h EN14080</option>
        <option value="18">GL24h EN14080</option>
        <option value="19">GL26h EN14080</option>
        <option value="20">GL28h EN14080</option>
        <option value="21">GL30h EN14080</option>
        <option value="22">GL32h EN14080</option>
        <option value="23">C14</option>
        <option value="24">C16</option>
        <option value="25">C18</option>
        <option value="26">C20</option>
        <option value="27">C22</option>
        <option value="28">C24</option>
        <option value="29">C27</option>
        <option value="30">C30</option>
        <option value="31">C35</option>
        <option value="32">C40</option>
        <option value="33">C45</option>
        <option value="34">C50</option>
        <option value="35">D18</option>
        <option value="36">D24</option>
        <option value="37">D27</option>
        <option value="38">D30</option>
        <option value="39">D35</option>
        <option value="40">D40</option>
        <option value="41">D45</option>
        <option value="42">D50</option>
        <option value="43">D55</option>
        <option value="44">D60</option>
        <option value="45">D65</option>
        <option value="46">D70</option>
        <option value="47">D75</option>
        <option value="48">D80</option>
        <option value="49">C14 BT</option>
        <option value="50">C16 BT</option>
        <option value="51">C18 BT</option>
        <option value="52">C20 BT</option>
        <option value="53">C22 BT</option>
        <option value="54">C24 BT</option>
        <option value="55">C27 BT</option>
        <option value="56">C30 BT</option>
        <option value="57">C35 BT</option>
      </select>
    </div>
  );
}

export default React.forwardRef(TimberMaterialPicker);
